import * as Sentry from "@sentry/react";

/**
 * Run a startup initializer so that a throw can never prevent React from
 * mounting. The initializers in main.tsx run at module load, before
 * createRoot().render() — an exception there blanks the entire app for the
 * affected user (#3558: posthog-js throwing in Blob-less WebViews).
 * Failures are logged and reported, never rethrown.
 */
export function safeInit(label: string, init: () => void): void {
  try {
    init();
  } catch (error) {
    console.error(`[${label}] initialization failed — continuing without it`, error);
    try {
      Sentry.captureException(error, { tags: { init_step: label } });
    } catch {
      // Sentry itself unavailable — the console log above is the fallback.
    }
  }
}
